import { type RouteRecordRaw } from 'vue-router'

import { useFeatureFlags } from '@/utils/useFeatureFlags'
import { type AuthZFn } from '@/vue-router'

const canAccessInbox: AuthZFn = ({ user }) => {
  const featureFlags = useFeatureFlags()

  return (
    (featureFlags.isEnabled('hermes.inbox') ||
      featureFlags.isEnabled('hermes.internalInbox')) &&
    user.can('read', 'inbox.thread')
  )
}

export const inboxRouter: RouteRecordRaw[] = [
  {
    component: async () => import('../views/InboxView.vue'),
    meta: {
      authZ: canAccessInbox,
      title: 'inbox',
    },
    name: 'brand.inbox',
    path: 'inbox',
  },
]
